import './filters-mobile.scss'

import { useUserRegionCH } from '@cdc-internal/mkt-nav-footer'
import _ from 'lodash'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useUKAccess } from '@/modules/useUKAccess'
import { useGeoCountry } from '@/utils/useGeoCountry'

import { ReactComponent as ChevronIcon } from '../../assets/icons/crypto_general_icons_chevron-down_clean.svg'
import { ReactComponent as CloseIcon } from '../../assets/icons/crypto_general_icons_close.svg'
import { useCategories } from '../../hooks/useCategories'
import Button from '../button/button'
import { useHashUrlFilter } from '../filters/use-hash-url-filter'
import SearchBoxFilter from '../search-box-filter/search-box-filter'

const researchCatOrder = {
  'Most Read': 0,
  Feature: 1,
  'Market Sizing': 2,
  Roundup: 3,
  DeFi: 4,
  Surveys: 5,
  Others: 6,
}

const FilterMobile = ({
  title,
  titleTwo,
  selectedCategories = {},
  type = 'event',
  typeTwo = undefined,
  onClick,
}) => {
  const [subCategories, setSubCategories] = useState([])
  const [subCategoriesTwo, setSubCategoriesTwo] = useState([])
  const [isOpen, setIsOpen] = useState(false)
  const [categories, setCategories] = useState([])
  const { withSubCategories } = useCategories()
  const { t } = useTranslation()
  const [filterTopPosition, setFilterTopPosition] = useState(62)
  const [navContainerHeight, setNavContainerHeight] = useState(0)

  const [firstRendering, setFirstRendering] = useState(true)
  const { geoCountry } = useGeoCountry()
  const isUKIp = useUKAccess()
  const userRegion = useUserRegionCH()

  useEffect(() => {
    const observeHeightChanges = () => {
      const filterElement = document.querySelector('.navbar-container') // Replace with the actual ID of your filter element
      if (filterElement) {
        const { height } = filterElement.getBoundingClientRect()
        setNavContainerHeight(Math.floor(height))
      }
    }

    const mutationObserver = new MutationObserver(observeHeightChanges)

    observeHeightChanges() // Initial height check

    mutationObserver.observe(document, {
      attributes: true,
      childList: true,
      subtree: true,
    })

    const handleWindowResize = () => {
      observeHeightChanges()
    }

    window.addEventListener('resize', handleWindowResize)

    return () => {
      mutationObserver.disconnect()
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  useEffect(() => {
    if (userRegion === 'UK' || (userRegion === 'EEA' && geoCountry === 'BE')) {
      if (firstRendering) {
        setFilterTopPosition(navContainerHeight)
        setFirstRendering(false)
        return
      }

      if (typeof document !== 'undefined') {
        const navbarBannerElem = document.getElementById('navbar-banner')
        if (navbarBannerElem) {
          if (isOpen) {
            navbarBannerElem.style.display = 'none'
            setFilterTopPosition(62)
          } else {
            navbarBannerElem.style.display = 'block'
            setFilterTopPosition(navContainerHeight)
          }
        }
      }
    }
  }, [isOpen, userRegion, firstRendering, navContainerHeight, geoCountry])

  const selectedRef = useRef(selectedCategories)
  useEffect(() => {
    selectedRef.current = selectedCategories
  }, [selectedCategories])

  const handleOnChangeFilters = (cat) => {
    selectedRef.current[type] = cat
  }

  const handleOnChangeFiltersTwo = (cat) => {
    selectedRef.current[typeTwo] = cat
  }

  const applyFilters = () => {
    onClick(selectedRef.current)
    setIsOpen(false)
    document.body.style.overflowY = 'unset'
    document.body.style.height = 'unset'
  }

  const handleResetFilters = () => {
    if (typeTwo) {
      onClick({ [type]: null, [typeTwo]: null })
    } else {
      onClick({ [type]: null })
    }

    selectedRef.current = {}
    setIsOpen(false)
    document.body.style.overflowY = 'unset'
    document.body.style.height = 'unset'
  }

  useEffect(() => {
    const cat = _.map(withSubCategories, (c) => ({
      id: c.description,
      value: c.description,
      label: c.name,
      slug: c.slug,
      description: c.description,
      children: c.wpChildren.map((child) => ({
        label: child.name,
        value: child.description,
        description: child.description,
        slug: child.slug,
      })),
    }))
    setCategories(cat)
  }, [withSubCategories])

  useEffect(() => {
    const category = _.filter(withSubCategories, (c) => c.description === type)
    let categoryArray = _.get(_.head(category), 'wpChildren', [])
    if (type === 'university' && isUKIp) {
      categoryArray = _.filter(
        categoryArray,
        (c) => c.slug !== 'derivatives-university-en'
      )
    }
    if (type === 'product-news' && userRegion === 'FR') {
      categoryArray = _.filter(
        categoryArray,
        (c) => c.slug !== 'exchange-product-news-en'
      )
    }

    if (type === 'product-news' && userRegion === 'AE') {
      categoryArray = _.filter(
        categoryArray,
        (c) => c.slug !== 'pay-product-news-en'
      )
    }

    setSubCategories(categoryArray)
    if (typeTwo) {
      const category2 = _.filter(
        withSubCategories,
        (c) => c.description === typeTwo
      )
      setSubCategoriesTwo(_.get(_.head(category2), 'wpChildren', []))
    }
  }, [type, typeTwo, withSubCategories, isUKIp, userRegion])

  useHashUrlFilter(
    selectedCategories,
    subCategories,
    subCategoriesTwo,
    type,
    typeTwo,
    onClick
  )

  return (
    <div className="container-filter-mobile" style={{ top: filterTopPosition }}>
      {!isOpen && (
        <div className="box-filter-mobile">
          <p className="text-type-filters">
            Filter{' '}
            <span>
              ({Object.values(selectedCategories).filter((c) => !!c).length})
            </span>
          </p>
          <div
            className="box-icon-chevron"
            onClick={() => {
              document.body.style.overflowY = 'hidden'
              document.body.style.height = '100%'
              setIsOpen(true)
            }}
          >
            <ChevronIcon className="icon-chevron" />
          </div>
        </div>
      )}
      {isOpen && (
        <div className="container-filters-mobile">
          <div className="box-filters-mobile">
            <div className="header-filter-mobile">
              <span
                className="closed-button"
                onClick={() => {
                  setIsOpen(false)
                  document.body.style.overflowY = 'unset'
                  document.body.style.height = 'unset'
                }}
              >
                <CloseIcon className="icon-close" />
              </span>
              <p className="title-filter-mobile">Filter</p>
              <span className="reset-button" onClick={handleResetFilters}>
                Reset
              </span>
            </div>
            <div className="content-filters-mobile">
              <SearchBoxFilter
                title={t(`ui.filters.${title}`)}
                type={type}
                isMobile={true}
                options={categories}
                selectedSortBy={selectedCategories[type]}
                onChange={(array) => handleOnChangeFilters(array)}
              />
            </div>
            {typeTwo && (
              <div className="content-filters-mobile">
                <SearchBoxFilter
                  title={t(`ui.filters.${titleTwo}`)}
                  type={typeTwo}
                  isMobile={true}
                  options={categories}
                  selectedSortBy={selectedCategories[typeTwo]}
                  onChange={(array) => handleOnChangeFiltersTwo(array)}
                />
              </div>
            )}
          </div>
          <div className="button-filter-mobile">
            <Button title="apply" onPress={applyFilters} />
          </div>
        </div>
      )}
    </div>
  )
}

export default FilterMobile
